<script>
/* -------------------------------------------------------------------------------------
The Notification bar displays the errors and success notifications

Main components
---------------
Methods:
- 

ACTION: different actions trigger several API calls. Each returning a potential error
        message. However, only the last error message is displayed. Goal it so bundle
        these API notifications and display them all together in one message
---------------------------------------------------------------------------------------*/

import { mapActions } from 'vuex'

export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      timeout: null
    }
  },

  mounted() {
    this.timeout = setTimeout(() => this.remove(this.notification), 5000)
  },

  beforeDestroy() {
    clearTimeout(this.timeout)
  },

  computed: {
    notificationTypeClass() {
      return `-text-${this.notification.type}`
    }
  },

  methods: mapActions('notification', ['remove'])
}
</script>

<template>
  <div class="notification-bar" :class="notificationTypeClass">
    <p>{{ notification.message }}</p>
  </div>
</template>

<style scoped>
.notification-bar {
  border: 5px;
}
</style>
